<template>
  <div class="list-view-main-container">
    <div class="list-view-container lvc-main">
      <div v-for="(item, index) in listViewItems" :key="index">
        <div class="list-view-item-normal list-view-item" :style="`top:${94 * item.row}px; left:${119 * item.column}px`">
          <div class="list-view-icon-container">
            <svg viewBox="0 0 38.4 38.4" width="36px" height="36px" fill="rgb(96,125,139)">
              <g transform="matrix(.01815 0 0 -.01697 1.93 35.587)"><path d="M493 1892c-141-50-224-191-195-330 61-292 467-326 571-48 26 71 27 130 1 199-57 151-228 232-377 179zM991 1729c32-102 19-224-32-315-30-52-105-130-151-156l-38-22V200H598l-173-1 30-25c46-38 182-100 270-123 155-41 333-37 484 10 78 23 197 82 237 115l29 24-175-1-175-1-3 411-2 411H830v240h930l-21 43c-101 198-292 364-505 437-46 16-217 50-255 50-4 0 2-27 12-61zM186 1348c-86-155-116-269-116-444 0-188 50-353 153-504 36-53 130-154 170-182l27-19v1037l-38 22c-41 23-142 124-142 141 0 27-22 6-54-51z"></path><path d="M1480 609V198l39 32c90 70 179 189 236 313 52 113 66 178 72 335l6 142h-353V609z"></path></g>
            </svg>
          </div>
          <div class="list-view-caption">
            {{item.name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data: () => ({
    listViewItems: [
      {
        name: 'ListViewItem',
        row: 0,
        column: 0
      },
      {
        name: 'ListViewItem',
        row: 1,
        column: 1
      },
      {
        name: 'ListViewItem',
        row: 2,
        column: 2
      }
    ]
  })
}
</script>
<style>
  .list-view-main-container {
    min-height: 300px;
    min-width: 360px;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  }
</style>